var exports = {
  "UX": "PlutoniumUpsell.module__upsell___SUNxeE",
  "Kk": "PlutoniumUpsell.module__icon___SUNxeE",
  "Qs": "PlutoniumUpsell.module__content___SUNxeE",
  "Qq": "PlutoniumUpsell.module__text___SUNxeE",
  "o1": "PlutoniumUpsell.module__actions___SUNxeE",
  "R3": "PlutoniumUpsell.module__dismissLink___SUNxeE",
};

module.exports = exports;
